<template>
  <Modal name="ADDITIONAL_INFO_APPOINTMENT_CONFIRM_TO_CLOSE_MODAL" :title="$t('appointment.additionalData.modal.confirmToCloseTitle')" actions>
    <template v-slot:body>
      <v-alert type="warning">
        <span>{{ $t('appointment.additionalData.modal.confirmToClose') }}</span>
      </v-alert>
    </template>
    <template v-slot:actions>
      <v-btn @click="cancelModal" class="mr-5" elevation="0" large text>
        {{ $t('appointment.additionalData.modal.cancel') }}
      </v-btn>
      <v-btn @click="closeAllModals" color="primary" elevation="0" large>
        {{ $t('appointment.additionalData.modal.confirm') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

import Modal from '@/components/app/Modal'

export default {
  name: 'ModalUpdateAdditionalInfoConfirmToClose',

  components: {
    Modal,
  },

  methods: {
    ...mapActions(['closeModal']),
    ...mapMutations(['closeAllModals', 'openModal']),

    cancelModal() {
      this.closeModal('ADDITIONAL_INFO_APPOINTMENT_CONFIRM_TO_CLOSE_MODAL')
      this.openModal('ADDITIONAL_INFO_APPOINTMENT_MODAL')
    }
  },
}
</script>
